import React from 'react';
import T from 'prop-types';

import SimpleDropdown from '../../../../components/Dropdowns/SimpleDropdown';

const SegmentDropdown = ({
  active,
  data,
  disabled,
  disabledSegments,
  unselectedStateText,
  formatButtonLabel,
  onChange,
}) => {
  const options = data.map((item) => ({
    value: item.cohort,
    label: (
      <>
        <span className="title">{item.title}</span>
        {item.subtitle && <span className="subtitle">({item.subtitle})</span>}
      </>
    ),
    disabled: disabledSegments ? disabledSegments.includes(item.cohort) : false,
    ...(formatButtonLabel ? { buttonLabel: formatButtonLabel(item) } : {}),
  }));

  return (
    <div className="segment-dropdown-container">
      <SimpleDropdown
        frameless
        selected={active}
        options={options}
        disabled={disabled}
        unselectedStateText={unselectedStateText}
        className="segment-dropdown-menu"
        onChange={onChange}
      />
    </div>
  );
};

SegmentDropdown.propTypes = {
  active: T.string,
  data: T.arrayOf(
    T.shape({
      cohort: T.string,
      title: T.string,
      subtitle: T.string,
    })
  ).isRequired,
  disabled: T.bool,
  disabledSegments: T.arrayOf(T.string),
  unselectedStateText: T.node,
  formatButtonLabel: T.func,
  onChange: T.func.isRequired,
};

export default SegmentDropdown;
